import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { SingleImageDropzone } from "../DropzoneComponents";   // yolu projene göre düzelt
import { toast } from "react-toastify";

const API   = `${process.env.REACT_APP_API_BASE_URL}`;
const IMG_W = 120;   // crop genişliği
const IMG_H = 120;   // crop yüksekliği

const InstitutionEdit = () => {
  const { id }   = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "", city: "", district: "", slogan: "",
    coverUrl: "",   // mevcut URL (string)
    file: null      // yeni seçilen / kırpılan File
  });

  /* ───────── mevcut veriyi getir ───────── */
  useEffect(() => {
    axios.get(`${API}/api/institution/${id}`).then(({ data }) =>
      setForm({
        title:    data.title,
        city:     data.city,
        district: data.district,
        slogan:   data.slogan || "",
        coverUrl: data.cover ? `${API}${data.cover}` : "",
        file:     null,
      })
    );
  }, [id]);

  /* ───────── metin alanları ───────── */
  const onInput = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  /* ───────── SingleImageDropzone’tan gelen setter ───────── */
  const mergeCover = (payload) => {
    setForm((prev) => {
      const obj = typeof payload === "function" ? payload(prev) : payload;

      /* Sil düğmesine basıldığında { file:null } gelir */
      if (obj && obj.file === null) {
        return { ...prev, file: null, coverUrl: "" };
      }
      return { ...prev, ...obj };
    });
  };

  /* ───────── gönder ───────── */
const onSubmit = async (e) => {
  e.preventDefault();

  const fd = new FormData();
  fd.append("title",    form.title);
  fd.append("city",     form.city);
  fd.append("district", form.district);
  fd.append("slogan",   form.slogan);

  if (form.file) {
    fd.append("cover", form.file); // yeni görsel
  } else if (!form.coverUrl) {
    fd.append("removeCover", 1); // eskiyi sil
  }

  try {
    await axios.put(`${API}/api/institution/${id}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    toast.success("Kurum başarıyla güncellendi.");
    setTimeout(() => {
      navigate("/institutions/table");
    }, 1500);

  } catch (err) {
    console.error("❌ Güncelleme hatası:", err);
    toast.error("Güncelleme sırasında bir hata oluştu.");
  }
};

  /* ───────── JSX ───────── */
  return (
    <div className="container mt-4">
      <form
        onSubmit={onSubmit}
        encType="multipart/form-data"
        className="card shadow-sm overflow-hidden"
      >
        <div className="card-header fw-bold">Kurum Bilgileri</div>

        <div className="card-body">
          {/* Görsel */}
          <div className="row mb-4">
            <div className="col-md-2 text-md-end fw-semibold pt-2">Görsel:</div>
            <div className="col-md-10">
              <SingleImageDropzone
                fieldName="file"                          // form.file
                fieldValue={form.file || form.coverUrl}  // File veya URL
                setFieldValues={mergeCover}
                required={false}
                maxWidth={IMG_W}
                maxHeight={IMG_H}
              />
            </div>
          </div>

          {/* Diğer alanlar */}
          {[
            ["title",    "Başlık",  true ],
            ["city",     "İl",      true ],
            ["district", "İlçe",    true ],
            ["slogan",   "Slogan",  false],
          ].map(([name, label, req]) => (
            <div className="row mb-3" key={name}>
              <div className="col-md-2 text-md-end fw-semibold pt-2">
                {label}:
              </div>
              <div className="col-md-10">
                <input
                  className="form-control"
                  name={name}
                  value={form[name]}
                  onChange={onInput}
                  required={req}
                />
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-center">
            <button className="btn btn-primary">Kaydet</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default InstitutionEdit;
